import React, { useEffect, useRef, useState } from "react";
import DoctorInformation from "./DoctorInformation";
import { Navigation, Pagination, Scrollbar, A11y, Controller } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { HiOutlineArrowLeft, HiOutlineArrowRight } from "react-icons/hi";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useSelector } from "react-redux";
import axios from "axios";
import config from "../../../config";

const DoctorPerformance = ({ selectedDoctor }) => {
  const uRegister = useSelector((state) => state.uRegister);

  const [doktorlar, setDoktorlar] = useState([]);
  const [openTab, setOpenTab] = useState(0);
  const [swiper, setSwiper] = useState();
  const prevRef = useRef();
  const nextRef = useRef();
  useEffect(() => {
    if (swiper) {
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }, [swiper]);

  useEffect(() => {
    const getAppointment = async () => {
      try {
        const response = await axios.get(
          `${config.API_BASE_URL}klinik_doktorlar/${uRegister.id}`,
          {
            headers: {
              Authorization: "Bearer " + uRegister.token, // Authorization
            },
          }
        );
        setDoktorlar(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    getAppointment();
  }, []);

  useEffect(() => {
    setOpenTab(selectedDoctor);
  }, [selectedDoctor]);

  return (
    <div>
      {/* <-----Card Hekimler ----->👇🏻 */}
      <div className="flex flex-row justify-between mb-4 px-2">
        <p className="text-lightGray">
          Performans görüntülemek için bir hekim seçin.
        </p>
        <article className="flex gap-3">
          <button
            ref={prevRef}
            className="bg-container w-10 h-10 flex items-center justify-center rounded-full"
          >
            <HiOutlineArrowLeft />
          </button>
          <button
            ref={nextRef}
            className="bg-container w-10 h-10 flex items-center justify-center rounded-full"
          >
            <HiOutlineArrowRight />
          </button>
        </article>
      </div>
      <Swiper
        className="flex flex-row gap-5"
        spaceBetween={25}
        slidesPerView={5}
        onSwiper={setSwiper}
        modules={[Navigation, Pagination, Scrollbar, A11y, Controller]}
        navigation={{
          prevEl: prevRef?.current,
          nextEl: nextRef?.current,
        }}
        updateOnWindowResize
        observer
        observeParents
      >
        {doktorlar.length > 0 &&
          doktorlar?.map((doktor, index) => (
            <SwiperSlide
              key={index}
              className={` ${
                openTab === doktor?.d_diploma_no
                  ? "card w-1/5 bg-gradient-to-r  from-blue1 to-blue2 text-white"
                  : "card w-1/5 bg-container"
              }`}
              onClick={(e) => {
                e.preventDefault();
                setOpenTab(doktor?.d_diploma_no);
              }}
            >
              <figure className="pt-5">
                <img
                  src={doktor?.d_resim}
                  alt="Shoess"
                  className="w-36 h-36 rounded-full object-contain bg-white border border-lightGray"
                />
              </figure>
              <div className="text-center py-3">
                <h2 className="text-center text-xl font-semibold  line-clamp-2 truncate px-3">
                  {doktor?.d_adi} {doktor?.d_soyadi}
                </h2>
                <p
                  className={` ${
                    openTab === doktor?.d_diploma_no
                      ? "text-white text-center h-10"
                      : "text-blue1 text-center h-10"
                  }`}
                >
                  {doktor?.d_unvan}
                </p>
              </div>
            </SwiperSlide>
          ))}
      </Swiper>
      {/* <-----Hekim Profil ----->👇🏻 */}
      {doktorlar.length > 0 && (
        <DoctorInformation
          doktorInfo={
            doktorlar?.filter((doktor) => doktor?.d_diploma_no === openTab)[0]
          }
          doktorlar={doktorlar}
        />
      )}
    </div>
  );
};

export default DoctorPerformance;
